// extracted by css-extract-rspack-plugin
export default {"root":"root-uizUjc","wrap":"wrap-MeSSNi","controls":"controls-L3DXxW","button":"button-r6w_EK","divider":"divider-l7L_Nh"};